import {SESSION_VARS} from "@/global/constants";

const KEY = SESSION_VARS.CURRENT_COMPANY;

/**
 * Acceso único a la empresa activa guardada en localStorage (axiosConfig la envía en el header companyId).
 */
export default {
    get: () => localStorage.getItem(KEY),
    set: companyId => localStorage.setItem(KEY, companyId),
    clear: () => localStorage.removeItem(KEY),
};
